module.exports = __webpack_public_path__ + "static/media/powered_by_logo.7b3676f1.png";